import { render, staticRenderFns } from "./topicItem.vue?vue&type=template&id=e9a9eec4&scoped=true"
import script from "./topicItem.vue?vue&type=script&lang=js"
export * from "./topicItem.vue?vue&type=script&lang=js"
import style0 from "./topicItem.vue?vue&type=style&index=0&id=e9a9eec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a9eec4",
  null
  
)

export default component.exports